import React from 'react';
import PropTypes from 'prop-types';
import { withConfig } from 'HOCs/withConfig/withConfig';
import classNames from 'classnames';
import css from './ShareButton.scss';
import { SHARE_BUTTON_CONSTANTS } from './Constants';
import IconWrapper from 'Components/IconWrapper/IconWrapper';
import { ICONS_SIZE } from 'Constants/items';

export class SocialLink extends React.Component {
    static propTypes = {
        social: PropTypes.object.isRequired,
        path: PropTypes.string.isRequired,
        text: PropTypes.string.isRequired,
        globalsConfig: PropTypes.object.isRequired
    };

    constructor(props) {
        super(props);
        const { social } = props;
        const url = props.globalsConfig.get('host') + props.path;
        const text = props.text;

        this.itemUrl = document.location.href;

        this.state = {
            socialUrl: social.url?.replace(/<<url>>/g, url).replace('<<text>>', text).replace('<<appId>>', props.globalsConfig.get('login').facebookAppId)
        };
    }

    render() {
        const { social } = this.props;
        const innerIconClassNames = classNames(css.icon, { [css.mobileOnly]: social.mobileOnly });

        if (social.track === SHARE_BUTTON_CONSTANTS.LINK) {
            return (<div className={ innerIconClassNames }
                rel="noopener noreferrer nofollow"
                data-aut-id={ SHARE_BUTTON_CONSTANTS.LINK_WRAPPER }>
                <IconWrapper className={ css.innerIcon } icon={ social.icon } dataAutId={ SHARE_BUTTON_CONSTANTS.LINK } size={ ICONS_SIZE.MEDIUM_ICONS } />
                {social.name}
            </div>
            );
        }

        if (social.track === SHARE_BUTTON_CONSTANTS.EMAIL) {
            return (
                <div className={ innerIconClassNames }
                    rel="noopener noreferrer nofollow"
                    data-aut-id={ SHARE_BUTTON_CONSTANTS.EMAIL_WRAPPER }>
                    <IconWrapper className={ css.innerIcon } icon={ social.icon } dataAutId={ SHARE_BUTTON_CONSTANTS.EMAIL } size={ ICONS_SIZE.MEDIUM_ICONS } />
                    {social.name}
                </div>
            );
        }

        return (
            <div rel="noopener noreferrer nofollow"
                className={ innerIconClassNames }
                data-url={ this.state.socialUrl }
                data-aut-id={ SHARE_BUTTON_CONSTANTS.SOCIAL_WRAPPER }
            ><IconWrapper className={ css.innerIcon } icon={ social.icon } dataAutId={ SHARE_BUTTON_CONSTANTS.SOCIAL } size={ ICONS_SIZE.MEDIUM_ICONS } />
                {social.name}</div>
        );
    }
}

export default withConfig('globalsConfig')(SocialLink);
